import React from "react"
import { Grid, Label } from "semantic-ui-react"

const HouseholdsTableRow = ({
  name,
  state,
  id,
  setCurrentHousehold,
  currentHouseholdId
}) => {
  return (
    <Grid.Row columns="equal" style={{ borderBottom: "1px solid #dcd6d6" }}>
      <Grid.Column
        textAlign="left"
        width={8}
        verticalAlign="middle"
        style={{ color: "#00b5ed", fontWeight: "600" }}
      >
        <span
          onClick={() => setCurrentHousehold(id)}
          style={{ paddingRight: "1em", cursor: "pointer" }}
        >
          {name}
        </span>
        {id === currentHouseholdId ? (
          <Label color="blue" horizontal>
            Current
          </Label>
        ) : (
          false
        )}
      </Grid.Column>
      <Grid.Column
        textAlign="right"
        width={7}
        verticalAlign="middle"
        style={{ color: "#00b5ed", fontWeight: "600" }}
      >
        {state}
      </Grid.Column>
    </Grid.Row>
  )
}

const HouseholdsTable = ({
  households,
  setCurrentHousehold,
  currentHouseholdId
}) => {
  return (
    <Grid.Row columns="equal">
      <Grid.Column textAlign="center" verticalAlign="middle">
        <Grid textAlign="center" divided>
          {households.map(({ id, description, primary_state_of_residence }) => {
            return (
              <HouseholdsTableRow
                key={id}
                name={description || "New Household"}
                state={primary_state_of_residence}
                {...{
                  id,
                  setCurrentHousehold,
                  currentHouseholdId
                }}
              />
            )
          })}
        </Grid>
      </Grid.Column>
    </Grid.Row>
  )
}

export default HouseholdsTable
